'use strict';

function Controller($stateParams, $http, $timeout, $rootScope, auth, pmtSiteInfoService, $i18next) {
	let siteName = $stateParams.site;
	let $ctrl = this;
	$ctrl.site = siteName;
	$ctrl.userIsAdmin = auth.user.isAdmin;
	$ctrl.userIsOwner = auth.user.localAccess.roles.has('owner');
	$ctrl.showSpinner = true;
	$ctrl.hasDiff = false;
	let timerPromise;

	this.$onDestroy = function () {
		$timeout.cancel(timerPromise);
		timerPromise = undefined;
	};

	$ctrl.splitUrl = function (url) {
		return new URL(url);
	};

	let calcHasDiff = function () {
		if ($ctrl.page && $ctrl.page.validation) {
			$ctrl.hasDiff =
				$ctrl.page.validation.dataDiff.coverImage.hasDiff ||
				$ctrl.page.validation.dataDiff.profileImage.hasDiff;
		} else {
			$ctrl.hasDiff = false;
		}
	};

	let pendingDiff = function () {
		return (
			$ctrl.page.validation.dataDiff.profileImage.pendingDiff ||
			$ctrl.page.validation.dataDiff.coverImage.pendingDiff ||
			($ctrl.page.validation.dataDiff.profileImage.work &&
				$ctrl.page.validation.dataDiff.profileImage.work.status === 'inProgress') ||
			($ctrl.page.validation.dataDiff.coverImage.work &&
				$ctrl.page.validation.dataDiff.coverImage.work.status === 'inProgress')
		);
	};

	function getPage() {
		$http
			.get('api/' + $ctrl.site + '/network/facebook/brandpages/' + $ctrl.brandPageId)
			.then(function (res) {
				if (!res.data.success) {
					return;
				}

				$ctrl.page = res.data.data;

				$ctrl.isCoverImageSet = res.data?.data?.media?.coverImage?.url?.length > 0;
				$ctrl.isProfileImageSet = res.data?.data?.media?.profileImage?.url?.length > 0;

				calcHasDiff();
				if (pendingDiff()) {
					if (timerPromise) {
						$timeout.cancel(timerPromise);
					}
					timerPromise = $timeout(getPage, 3000);
				} else if (!$ctrl.showPublishDialog && !$ctrl.facebookPublishSuccess) {
					if (
						$ctrl.originalPage &&
						res.data.data.data.coverPhoto === $ctrl.originalPage.data.coverPhoto &&
						res.data.data.data.profilePhoto === $ctrl.originalPage.data.profilePhoto
					) {
						if (timerPromise) {
							$timeout.cancel(timerPromise);
						}
						timerPromise = $timeout(getPage, 3000);
					}
				}
				$ctrl.showSpinner = false;

				if (!$ctrl.originalPage) {
					$ctrl.originalPage = res.data.data;
				}
			});
	}

	/**
	 * Get marked-up text saying something like: "You have 8 locations with
	 * individually set profile image."
	 *
	 * @description N.B. uses translation keys via concatenation:
	 * 	* general.location_cover_image
	 *  * general.location_profile_image
	 *
	 * @param {Number} notUsedCount
	 * @param {string} imageType 'profile'|'cover'
	 * @returns
	 */
	let getLocationUsageCountsSummaryHtml = function (notUsedCount, imageType) {
		const tNumOfLocations = $i18next.t('general.number_of_locations', { count: notUsedCount });
		const tImageType = $i18next.t(`general.location_${imageType}_image`);

		return $i18next.t('listings.brand_pages.individual_images', {
			notUsed: '<strong>' + tNumOfLocations.toLowerCase() + '</strong>',
			imageType: '<strong>' + tImageType.toLowerCase() + '</strong>'
		});
	};

	const sum = function (a, b) {
		return a + b.count;
	};

	let applyNewLocationUsageCounts = function (data, imageType) {
		const counts = {
			total: data.locations.reduce(sum, 0),
			notUsed: data.locations.filter(x => x._id === 'location').reduce(sum, 0)
		};

		counts.summaryText = getLocationUsageCountsSummaryHtml(counts.notUsed, imageType);
		$ctrl[imageType + 'LocationUsage'] = counts;
	};

	let refreshLocationUsageCounts = function (imageType) {
		$http
			.get(`api/${$ctrl.site}/media/${imageType}/facebook/status/connection/${$ctrl.brandPageId}`)
			.then(response => applyNewLocationUsageCounts(response.data, imageType));
	};

	let refreshLocalDeviations = function (imageType) {
		$http
			.get(`api/${$ctrl.site}/media/${imageType}/facebook/status/${$ctrl.brandPageId}`)
			.then(response => ($ctrl.deviations = response.data));
	};

	this.$onChanges = function (changes) {
		if (
			changes.brandPageId &&
			changes.brandPageId.currentValue &&
			changes.brandPageId.currentValue !== changes.brandPageId.previousValue
		) {
			$ctrl.page = null;
			getPage();
			refreshLocationUsageCounts('cover');
			refreshLocationUsageCounts('profile');
			$timeout.cancel(timerPromise);
			timerPromise = undefined;
		}
	};

	$ctrl.networkSettings = auth.user.selectedSite.analytics;

	$ctrl.fileSelectionIsDone = function (file, imageType) {
		let page = { media: {} };
		let url = `api/${$ctrl.site}/network/facebook/brandpages/${$ctrl.brandPageId}`;

		page.media[`${imageType}Image`] = {
			mediaRef: file._id,
			url: file.url,
			previewUrl: file.previewUrl,
			setType: 'regional'
		};

		pmtSiteInfoService.addWork();

		$http.patch(url, page).then(function (res) {
			getPage();
			$ctrl.editCoverImage = false;
			$ctrl.editProfileImage = false;

			if (res.data.success) {
				$ctrl.page = res.data.data;
				calcHasDiff();
			}
		});
	};

	$ctrl.publish = function () {
		$ctrl.showPublishDialog = true;
		$ctrl.showPublishProgress = 'ongoing';

		$http
			.put('api/' + siteName + '/facebook/conflict/publish/' + $ctrl.brandPageId, {
				site: siteName,
				id: $ctrl.brandPageId
			})
			.then(
				function (res) {
					$ctrl.showPublishProgress = false;

					if ($ctrl.onPublish) {
						$ctrl.onPublish();
					}

					if (res.status === 200 && res.data.success) {
						getPage();
						$ctrl.facebookPublishSuccess = true;
					} else {
						$ctrl.facebookPublishError = res.data.data;
						$ctrl.facebookPublishSuccess = false;
					}
				},
				function () {
					$ctrl.facebookPublishSuccess = false;
				}
			)
			.finally(function () {});
	};

	$ctrl.closePublishProgress = function () {
		$ctrl.showPublishDialog = false;
	};

	$ctrl.useFacebookImage = function (imageType) {
		$ctrl.page.validation.dataDiff[`${imageType}Image`].pendingDiff = true;
		let url = `api/${$ctrl.site}/network/facebook/brandpages/${$ctrl.brandPageId}/${imageType}image/use`;
		$http
			.post(url)
			.then(getPage)
			.catch(() => ($ctrl.page.validation.dataDiff[`${imageType}Image`].pendingDiff = false));
	};

	$ctrl.openDeviationsDialog = function (imageType) {
		$rootScope.$broadcast('updateImageType', { imageType: imageType });
		refreshLocalDeviations(imageType);
		$ctrl.deviationsDialogToShow = imageType;
	};

	$ctrl.closeDeviationsDialog = function (imageType) {
		$ctrl.deviationsDialogToShow = null;
		$ctrl.deviations = null;
		getPage();
		refreshLocationUsageCounts(imageType);
	};

	$ctrl.showImagePreview = function (url) {
		$ctrl.previewImage = url;
		$ctrl.showImagePreviewDialog = true;
	};
}

Controller.$inject = [
	'$stateParams',
	'$http',
	'$timeout',
	'$rootScope',
	'auth',
	'pmtSiteInfoService',
	'$i18next'
];

angular.module('pmtPlacesApp.controllers').component('pmtBrandpageBusinessInformation', {
	templateUrl: 'components/networks/facebook/pmtBrandpageBusinessInformation.html',
	controller: Controller,
	bindings: {
		brandPageId: '<',
		onPublish: '<'
	}
});
